export default __webpack_public_path__ + "static/media/Portada inicial.6e0212c2.jpg";